<template>
    <div class="stop-item">
        <md-button
            title="Send Sms to stop contact"
            class="md-success"
            :class="useIcon ? 'md-warning md-just-icon md-round' : `${className}`"
            :disabled="!isSmsEnabled"
            @click.stop="showSendSmsModal"
        >
            <span>Sms Contact</span>
        </md-button>
    </div>
</template>

<script>
import SendSmsModal from '@/pages/Stops/components/SendSmsModal';

export default {
    name: 'SendSmsButton',
    props: {
        stopId: {
            type: Number,
            required: true
        },
        stopContact: {
            type: Object,
            required: true
        },
        className: {
            type: String,
            default: () => ''
        },
        useIcon: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        isSmsEnabled() {
            if (!this.stopContact || !this.stopContact.phoneType) 
                return false;
            return this.stopContact.phoneType
                .split(',')
                .map((t) => t.trim())
                .includes('mobile');
        }
    },
    methods: {
        showSendSmsModal() {
            this.$modal.show(SendSmsModal, {
                stopId: this.stopId,
                stopContact: this.stopContact
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.stop-item {
    display: inline;
}
</style>
